<template>
    <div class="about-page" style="padding-top: 56px">
        <AboutComponent />
    </div>
</template>
  
<style lang="scss" scoped>
</style>